export type RemoteQueryPhase = 'none' | 'loading' | 'loaded' | 'error';

export const InteractionStateQuerySymbol = Symbol.for('InteractionStateQuery')

export interface InteractionStateQuery {
  remotePhase: RemoteQueryPhase;
}
